var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditingAndInclusion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.95 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#134fc8;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.28,13a1,1,0,1,0,0-1.95H38.2a1,1,0,0,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.45,5.54H6.36a1,1,0,0,0,0,2H9.45a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.45,11.07H6.36a1,1,0,0,0,0,1.95H9.45a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.64,7.49h.08a1,1,0,0,0,0-1.95h-.08a1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.56,13h.08a1,1,0,1,0,0-1.95h-.08a1,1,0,0,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.8,7.49h4.06a1,1,0,0,0,0-1.95H15.8a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.24,11.07h-4a1,1,0,1,0,0,1.95h4a1,1,0,1,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.94,7.49h2.88a1,1,0,0,0,0-1.95H22.94a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.05,12a1,1,0,0,0,1,1H27.9a1,1,0,0,0,0-1.95H25A1,1,0,0,0,24.05,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29,7.49h3.92a1,1,0,0,0,0-1.95H29a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.89,11.07H31A1,1,0,0,0,31,13h3.92a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.86,7.49h2.66a1,1,0,1,0,0-1.95H35.86a1,1,0,1,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.58,7.49h3a1,1,0,1,0,0-1.95h-3a1,1,0,0,0,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.58,13h3a1,1,0,1,0,0-1.95h-3a1,1,0,0,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.45,16.6H6.36a1,1,0,0,0,0,1.95H9.45a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.45,22.13H6.36a1,1,0,0,0,0,1.95H9.45a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.72,18.55a1,1,0,0,0,0-1.95h-.08a1,1,0,1,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.82,16.6H21.64a1,1,0,0,0,0,1.95h4.18a1,1,0,0,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.35,16.6H29a1,1,0,0,0,0,1.95h.34a1,1,0,1,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.52,16.6h-.84a1,1,0,0,0,0,1.95h.84a1,1,0,1,0,0-1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.58,18.55h3a1,1,0,1,0,0-1.95h-3a1,1,0,0,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.58,24.08h3a1,1,0,1,0,0-1.95h-3a1,1,0,0,0,0,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.19,29.21A2.76,2.76,0,0,0,51,26.44V2.76A2.76,2.76,0,0,0,48.19,0H2.76A2.77,2.77,0,0,0,0,2.76V26.44a2.77,2.77,0,0,0,2.76,2.77H14.18v1.44a3,3,0,0,0-1.63-.48,3.08,3.08,0,0,0-2.77,1.74,3,3,0,0,0-2-.72,3.06,3.06,0,0,0-2.73,1.68A3.08,3.08,0,0,0,0,35.21V47H21.25l1.93-4a3.2,3.2,0,0,0-.92-3.61,4.4,4.4,0,0,0-1.89-1V29.21H30.59v9.25a4.48,4.48,0,0,0-1.9,1A3.18,3.18,0,0,0,27.78,43l1.92,4H51V35.21a3.07,3.07,0,0,0-5.08-2.34,3.06,3.06,0,0,0-4.7-1,3.05,3.05,0,0,0-4.4-1.26V29.21ZM2.76,27.26A.82.82,0,0,1,2,26.44V2.76A.81.81,0,0,1,2.76,2H48.19a.82.82,0,0,1,.82.81V26.44a.82.82,0,0,1-.82.82H36.77V24.08h1a1,1,0,0,0,0-1.95h-1V19.88a3.09,3.09,0,0,0-6.18,0v2.25H20.37V19.88a3.1,3.1,0,0,0-6.19,0v2.25h-1a1,1,0,1,0,0,1.95h1v3.18ZM21.29,40.51a1.74,1.74,0,0,1,.55,1.93l-1.5,3.1H1.46V35.21a1.64,1.64,0,0,1,3.27,0v3.36a.73.73,0,0,0,1.46,0V34.28a1.63,1.63,0,0,1,3.26,0v3.27a.73.73,0,1,0,1.46,0V33.26a1.64,1.64,0,0,1,3.27,0v4.29a.73.73,0,1,0,1.46,0V19.88a1.64,1.64,0,0,1,3.27,0V40.55a.73.73,0,1,0,1.46,0V40A3.11,3.11,0,0,1,21.29,40.51Zm-.92-13.25V24.08H30.59v3.18Zm16.4,10.29V33.26a1.64,1.64,0,0,1,3.27,0v4.29a.73.73,0,0,0,1.46,0V34.28a1.64,1.64,0,0,1,3.27,0v4.29a.73.73,0,1,0,1.46,0V35.21a1.63,1.63,0,1,1,3.26,0V45.54H30.61l-1.5-3.1a1.74,1.74,0,0,1,.56-1.93,2.81,2.81,0,0,1,.92-.54v.58a.73.73,0,0,0,1.46,0V19.88a1.63,1.63,0,0,1,3.26,0V37.55a.73.73,0,1,0,1.46,0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditingAndInclusion);
export default __webpack_public_path__ + "static/media/editing-and-inclusion.86337df4d5f7ad5953903cda13d75804.svg";
export { ForwardRef as ReactComponent };